import useCurrentPage from "utilities/hooks/domain/notebooks/pages/use-current-page";
import useCurrentIdentity from "utilities/hooks/use-current-identity";

export interface UsePageIsViewOnly {
    isViewOnly: boolean;
}

export function usePageIsViewOnly(): UsePageIsViewOnly {
    const { currentPage } = useCurrentPage();
    const { currentIdentity } = useCurrentIdentity();

    const viewOnly = currentPage?.ownerId !== currentIdentity?.userId();

    return {
        isViewOnly: viewOnly,
    };
}
